/**
 * SPEC-RedDotOps §8.2 — the one wording rule for the "customer notified"
 * button and its activity-feed line, for every role:
 *
 *   QATT_1 (CookUnity)  → "CU Notified"
 *   every other QATT, or unknown → "POD Sent"
 *
 * One detection only (expected_qatt === 1), so a button and the feed can never
 * disagree. Supersedes the 2026-05-29 customer-agnostic "CX Notified" label.
 */
export function notifyLabel(expectedQatt: number | null | undefined): "CU Notified" | "POD Sent" {
  return expectedQatt === 1 ? "CU Notified" : "POD Sent";
}
